/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sections_Latestoffers1Inputs */

const id_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Terbaru`)
};

const ms_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Terkini`)
};

const da_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste Tilbud`)
};

const de_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste Angebote`)
};

const en_us2_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Offers`)
};

const es_es2_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadidos recientemente`)
};

const es_mx2_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregados recientemente`)
};

const fil_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pinakabagong Offer`)
};

const fr_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernières offres`)
};

const it_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime offerte`)
};

const hu_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legújabb ajánlatok`)
};

const nl_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwste aanbiedingen`)
};

const no_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste tilbud`)
};

const pl_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnio dodane`)
};

const pt_br2_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionados recentemente`)
};

const pt_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas recentes`)
};

const ro_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte recente`)
};

const fi_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät tarjoukset`)
};

const sv_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste erbjudandena`)
};

const vi_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi mới nhất`)
};

const tr_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Teklifler`)
};

const cs_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější nabídky`)
};

const bg_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-нови оферти`)
};

const ru_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние предложения`)
};

const uk_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні пропозиції`)
};

const ar_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث العروض`)
};

const hi_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम ऑफ़र`)
};

const th_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอล่าสุด`)
};

const ja_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新オファー`)
};

const zh_cn2_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新目录项`)
};

const zh_hant1_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新目錄項目`)
};

const ko_home_sections_latestoffers1 = /** @type {(inputs: Home_Sections_Latestoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신 오퍼`)
};

/**
* | output |
* | --- |
* | "Latest Offers" |
*
* @param {Home_Sections_Latestoffers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_sections_latestoffers1 = /** @type {((inputs?: Home_Sections_Latestoffers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sections_Latestoffers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_sections_latestoffers1(inputs)
	if (locale === "ms") return ms_home_sections_latestoffers1(inputs)
	if (locale === "da") return da_home_sections_latestoffers1(inputs)
	if (locale === "de") return de_home_sections_latestoffers1(inputs)
	if (locale === "en-US") return en_us2_home_sections_latestoffers1(inputs)
	if (locale === "es-ES") return es_es2_home_sections_latestoffers1(inputs)
	if (locale === "es-MX") return es_mx2_home_sections_latestoffers1(inputs)
	if (locale === "fil") return fil_home_sections_latestoffers1(inputs)
	if (locale === "fr") return fr_home_sections_latestoffers1(inputs)
	if (locale === "it") return it_home_sections_latestoffers1(inputs)
	if (locale === "hu") return hu_home_sections_latestoffers1(inputs)
	if (locale === "nl") return nl_home_sections_latestoffers1(inputs)
	if (locale === "no") return no_home_sections_latestoffers1(inputs)
	if (locale === "pl") return pl_home_sections_latestoffers1(inputs)
	if (locale === "pt-BR") return pt_br2_home_sections_latestoffers1(inputs)
	if (locale === "pt") return pt_home_sections_latestoffers1(inputs)
	if (locale === "ro") return ro_home_sections_latestoffers1(inputs)
	if (locale === "fi") return fi_home_sections_latestoffers1(inputs)
	if (locale === "sv") return sv_home_sections_latestoffers1(inputs)
	if (locale === "vi") return vi_home_sections_latestoffers1(inputs)
	if (locale === "tr") return tr_home_sections_latestoffers1(inputs)
	if (locale === "cs") return cs_home_sections_latestoffers1(inputs)
	if (locale === "bg") return bg_home_sections_latestoffers1(inputs)
	if (locale === "ru") return ru_home_sections_latestoffers1(inputs)
	if (locale === "uk") return uk_home_sections_latestoffers1(inputs)
	if (locale === "ar") return ar_home_sections_latestoffers1(inputs)
	if (locale === "hi") return hi_home_sections_latestoffers1(inputs)
	if (locale === "th") return th_home_sections_latestoffers1(inputs)
	if (locale === "ja") return ja_home_sections_latestoffers1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_sections_latestoffers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_sections_latestoffers1(inputs)
	return ko_home_sections_latestoffers1(inputs)
});
export { home_sections_latestoffers1 as "home.sections.latestOffers" }